/* eslint-disable max-len */
import { SvgProps } from './types'

export const TruckIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_9496_47652)">
        <path
          d="M4.44361 42.3229H2.96711C2.14684 42.3229 1.48242 41.6585 1.48242 40.8382V37.918C1.48242 37.0978 2.14684 36.4333 2.96711 36.4333H10.3906H22.2845H31.5126V42.3229H28.2315"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
          {...rest}
        />
        <path
          d="M31.5098 42.3231V7.71582H40.1144C41.6155 7.71582 51.5736 11.4235 51.5736 11.4235L52.7138 23.0467L53.9278 24.2607C54.5758 24.9087 54.9449 25.7946 54.9449 26.7215V39.0092"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.9396 14.4048H38.9992C39.3437 14.4048 39.6226 14.6837 39.6226 15.0282V22.4353C39.6226 22.7798 39.3437 23.0587 38.9992 23.0587C38.7449 23.0587 38.5234 22.911 38.425 22.6731L35.3654 15.2661C35.1931 14.8559 35.4966 14.4048 35.9396 14.4048Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.7305 23.0538H42.7015C42.357 23.0538 42.0781 22.7749 42.0781 22.4304V15.0233C42.0781 14.6788 42.357 14.3999 42.7015 14.3999H48.0005C48.3204 14.3999 48.5911 14.646 48.6157 14.9577L49.3375 22.3647C49.3868 22.7339 49.0997 23.0538 48.7305 23.0538Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.707 39.0024H52.0605H54.9314C55.4318 39.0024 55.8337 39.4044 55.8337 39.9047V44.0635C55.8337 44.5639 55.4318 44.9658 54.9314 44.9658H51.1582"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3393 42.373C16.3393 39.0919 13.6734 36.426 10.3923 36.426C7.1112 36.426 4.44531 39.0919 4.44531 42.373C4.44531 45.6541 7.1112 48.32 10.3923 48.32C13.6734 48.32 16.3393 45.6623 16.3393 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1966 42.373C13.1966 40.8226 11.9416 39.5676 10.3913 39.5676C8.84095 39.5676 7.58594 40.8226 7.58594 42.373C7.58594 43.9233 8.84095 45.1783 10.3913 45.1783C11.9416 45.1783 13.1966 43.9233 13.1966 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.2279 42.373C28.2279 39.0919 25.562 36.426 22.281 36.426C18.9999 36.426 16.334 39.0919 16.334 42.373C16.334 45.6541 18.9999 48.32 22.281 48.32C25.562 48.32 28.2279 45.6623 28.2279 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0833 42.373C25.0833 40.8226 23.8283 39.5676 22.278 39.5676C20.7277 39.5676 19.4727 40.8226 19.4727 42.373C19.4727 43.9233 20.7277 45.1783 22.278 45.1783C23.8283 45.1783 25.0833 43.9233 25.0833 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.7553 42.373C51.7553 39.0919 49.0894 36.426 45.8083 36.426C42.5272 36.426 39.8613 39.0919 39.8613 42.373C39.8613 45.6541 42.5272 48.32 45.8083 48.32C49.0976 48.32 51.7553 45.6623 51.7553 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.6126 42.373C48.6126 40.8226 47.3576 39.5676 45.8073 39.5676C44.257 39.5676 43.002 40.8226 43.002 42.373C43.002 43.9233 44.257 45.1783 45.8073 45.1783C47.3576 45.1783 48.6126 43.9233 48.6126 42.373Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.0703 39.0025V32.6044C52.0703 31.013 53.3581 29.7334 54.9413 29.7334"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0699 32.1748H21.0497L23.207 36.432H6.62109L8.77841 32.1748H11.7888"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.6406 42.323H39.8612"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.4043 26.1807H44.8077"
          stroke={drawColor}
          strokeWidth="2"
          strokeMiterlimit="13.3333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9496_47652">
          <rect width="56" height="56" fill="white" transform="translate(0.666016 0.0200195)" />
        </clipPath>
      </defs>
    </svg>
  )
}
